//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HotelDatePicker from '~/components/range/RangedatePicker';
import moment from 'moment';
export default {
  props: ['data', 'query'],
  data: function data() {
    var obj = {
      keyword: '',
      status: [],
      pageSize: [25, 50, 100],
      selectPage: this.query.pageSize || 50
      // console.log(obj)
    };if (this.query.keyword !== undefined) {
      obj.keyword = this.query.keyword;
    }
    if (this.query.status !== undefined) {
      if (this.query.status instanceof Array) {
        obj.status = this.query.status;
      } else {
        obj.status = [];
        obj.status.push(this.query.status);
      }
    }

    obj.fromDate = '';
    obj.toDate = '';
    if (this.query.fromDate !== undefined && this.query.fromDate !== '') {
      // console.log(this.query)

      obj.initRange = {
        start: this.query.fromDate,
        end: this.query.toDate
      };
    } else {
      var today = moment().format('YYYY-MM-DD');

      obj.initRange = {
        start: today,
        end: today
      };
      obj.fromDate = today;
      obj.toDate = today;
    }

    // obj.dateSend = {
    //   start: '2018-02-05',
    //   end: '2018-02-10'
    // }
    obj.captions = {
      title: 'Choose Dates',
      ok_button: 'Apply'
    };
    obj.i18n = 'EN';
    obj.shortDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    obj.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    // obj.startDate = ''
    // obj.endDate = ''
    return obj;
  },

  methods: {
    createlbl: function createlbl(obj) {
      return 'lbl lbl-status-' + obj.status.replace('&', '');
    },
    onDateSelected: function onDateSelected(rangeDate) {
      // console.log(rangeDate)

      // event.preventDefault()
      // console.log(rangeDate)
      var startDate = rangeDate.start;
      var endDate = rangeDate.end;
      var format = 'YYYY-MM-DD';
      var start = moment(startDate).add(-1, 'days').format(format);
      var end = moment(endDate).add(-1, 'days').format(format);

      this.initRange.start = start;
      this.initRange.end = end;
      this.fromDate = start;
      this.toDate = end;
    }
  },
  components: {
    HotelDatePicker: HotelDatePicker
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/creteria-bar.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/newdata/vhosts/musubi-thai.com/node_application/webapp/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/creteria-bar.vue
// module chunks = 18 19 20 21 22 23 24 25 26 27 28